import CoverPhoto from './cover-photo';

export default CoverPhoto;
